import { MultiSelectControlledOption } from "components";

export const getStatusOptions = (
  options: { key: string; value: string }[],
): MultiSelectControlledOption[] =>
  Array.isArray(options)
    ? options.map(({ key, value }) => ({
        name: value,
        label: value,
        value: key,
      }))
    : [];

export const findOrBuildOption = (
  value: string | number,
  options: MultiSelectControlledOption[],
): MultiSelectControlledOption =>
  options.find((o) => o.value === value) ?? {
    value,
    label: String(value),
    name: String(value),
  };
